import { setEnrollmentPermissionDetails } from '@actions/memberPortal/enrollmentsActionCreators';
import { setSideNavdetails, setStoredEncHouseholdId, syncHouseholdReferenceId } from '@actions/SideNav/sideNavActionCreators';
import { IEnrollmentDetail, IMenuPermissions } from '@modules/members/enrollments/common/types';
import useAppDispatch from './useAppDispatch';
import useSetSelectedEnrollment from './useSetSelectedEnrollment';

export const useSetSideNavDetailsFromEnrollment = () => {
    const dispatch = useAppDispatch();
    const setSelectedEnrollment = useSetSelectedEnrollment();

    const checkMenuPermissions = (permissions: IMenuPermissions) => {
        const result: { [key: string]: string } = {};
        if (!permissions) {
            return result;
        }
        for (const key in permissions) {
            if (Object.prototype.hasOwnProperty.call(permissions, key)) {
                result[key] = permissions[key] ? 'true' : 'false';
            }
        }
        return result;
    };

    const permissionString = (obj: Record<string, any>) => {
        return JSON.stringify(obj ?? {}).replace(/:/g, '=').replace(/,/g, ', ').replace(/"/g, '');
    };

    const setSessionStorage = (data: any, menuPermissions: Record<string, string>) => {
        sessionStorage.setItem('householdFirstName', data.hhFirstName);
        sessionStorage.setItem('householdLastName', data.hhLastName);
        sessionStorage.setItem('householdId', data.hhId);
        sessionStorage.setItem('permissionMap', permissionString(menuPermissions));
        sessionStorage.setItem('encHouseHoldId', data.encHHId);
    };

    return (EnrollmentDetails: IEnrollmentDetail) => {
        if (!EnrollmentDetails?.enrollmentDetail) {
            return;
        }
        const enrollment = JSON.parse(EnrollmentDetails.enrollmentDetail);
        const menuPermissions = checkMenuPermissions(EnrollmentDetails.menuPermissions);
        // API DTO exposes userPermissions; some callers historically used enrollmentPermissions.
        const userPermissions = EnrollmentDetails.userPermissions ?? EnrollmentDetails.enrollmentPermissions;
        const data = {
            hhFirstName: EnrollmentDetails?.household?.firstName,
            hhLastName: EnrollmentDetails?.household?.lastName,
            hhId: EnrollmentDetails?.householdId,
            permissionMap: menuPermissions,
            encHHId: EnrollmentDetails?.encHouseholdId,
            hhPhone: EnrollmentDetails?.household?.phoneNumber,
        };
        dispatch(setSideNavdetails(data));
        setSessionStorage(data, menuPermissions);
        if (EnrollmentDetails?.encHouseholdId) {
            setStoredEncHouseholdId(EnrollmentDetails.encHouseholdId);
        }
        dispatch(syncHouseholdReferenceId(EnrollmentDetails?.household));
        setSelectedEnrollment(enrollment);
        // Persist the full permission/household payload so SideNav deep-links
        // (premiumhistory/:eId with no household :id) can resolve context without crashing.
        dispatch(
            setEnrollmentPermissionDetails({
                userPermissions,
                menuPermissions: EnrollmentDetails.menuPermissions,
                household: EnrollmentDetails.household,
                householdId: EnrollmentDetails.householdId,
                encHouseholdId: EnrollmentDetails.encHouseholdId,
            }),
        );
    };
};
